export default {
    computed: {
        showEscalation() {
            let escalationPossible = false

            if((this.user.role == 'pit' || (this.user.is_admin && _.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1)) ){
                escalationPossible = true
            }

            // This option is not valid, you can always escalate but sending to deurwaarder is prompted.
            if(_.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1){
                if(!this.user.is_admin && (_.has(this.user.organisation_settings, 'escalation_admin') && this.user.organisation_settings.escalation_admin == 1)){
                    escalationPossible = false
                } else {
                    escalationPossible = true
                }
            }

            // Overrule for PIT admins
            if(this.user.role == 'pit'){
                escalationPossible = true
            }

            return escalationPossible
        },

        showOutEscalation() {
            let escalationPossible = false

            if((_.has(this.user.organisation_settings, 'escalation') && this.user.organisation_settings.escalation == 1) && (_.has(this.user.organisation_settings, 'escalation_out') && this.user.organisation_settings.escalation_out == 1)){
                // no admin and rights not possible
                if(!this.user.is_admin && (!_.has(this.user.organisation_settings, 'escalation_out_admin') || this.user.organisation_settings.escalation_out_admin == 1)){
                    escalationPossible = false
                }
                if(!this.user.is_admin && (!_.has(this.user.organisation_settings, 'escalation_out_admin') || this.user.organisation_settings.escalation_out_admin == false)){
                    escalationPossible = true
                }

                // admin and rights possible
                if(this.user.is_admin){
                    escalationPossible = true
                }
            }

            // Overrule for PIT admins
            if(this.user.role == 'pit'){
                escalationPossible = true
            }

            return escalationPossible
        },

        cantEscalate() {
            return this.type == 'geescaleerd' || !_.isNull(this.record?.paid) || this.type == 'credit'
        },

        escalationName() {
            return _.has(this.user, 'organisation_settings.escalation_name') ? this.user.organisation_settings.escalation_name : 'escalatie'
        }
    }
}